var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e8dcff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud_2",
    "data-name": "cloud 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M502.88,488.47c14.81-9.43,28.51-20.67,44.06-28.82,38.16-20,86.54-18.92,123.78,2.73,31.32,18.21,58.53,50.78,94.71,48.89,31.11-1.62,53.89-28.33,78.68-47.2,49.6-37.76,119.71-44.67,177.06-21.19,10.55,4.32,9.5,19.38-1.51,22.33a92.79,92.79,0,0,0-30.93,15.06c-21,15.54-35.84,37.82-49.86,59.86s-28,44.7-47.93,61.6c-39,33-99.2,38.07-143.09,12-20.77-12.36-37.39-30.46-56.07-45.79s-41.16-28.43-65.31-27.6c-44.66,1.55-74.3,47.81-116.35,62.93-33.56,12.06-74.09,1.21-97.13-26-12.21-14.42-38.09-76.2-9.5-86.15,13-4.51,31.06,12.37,43.89,14.14C467.12,507.93,486.66,498.79,502.88,488.47Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects16);
export default __webpack_public_path__ + "static/media/objects-16.0eec5e1cadd2ec5e63dd1a8d5e342890.svg";
export { ForwardRef as ReactComponent };